module.exports = __webpack_public_path__ + "static/img/icon-setting.bea7c239.svg";